/* this file added by Bearer Web Developer  */
import React, { useState } from "react";
import { PositionMenu, TodayDeliveriesContext } from "../../../states/contexts/TodayDeliveries";

const TodayDeliveriesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [positionMenu, setPositionMenu] = useState<PositionMenu>('top');
  const openMenu = (el: HTMLElement, position?: PositionMenu) => {
    if (position) setPositionMenu(position);
    else if (positionMenu !== 'top') setPositionMenu('top');
    setAnchorEl(el)
  };
  const closeMenu = () => setAnchorEl(null);
  return (
    <TodayDeliveriesContext.Provider value={{ anchorEl, openMenu, positionMenu, closeMenu }}>
      {children}
    </TodayDeliveriesContext.Provider>
  );
};
export default TodayDeliveriesProvider;